import { graphql } from "../../graphql";

export const KeyMessageGroupFragment = graphql(`
    fragment KeyMessageGroupFragment on KeyMessageGroupType @_unmask {
        id
        name
        __typename
    }
`);

export const KeyMessageItemFragment = graphql(`
    fragment KeyMessageItemFragment on KeyMessageItemType @_unmask {
        id
        name
        searchTerms
        feedArticleFilters
        total
        groupId
        __typename
    }
`);
